export default __webpack_public_path__ + "static/media/celebrate.0cf58f6252ae6f4197cf56520a4177fc.svg";